import styled from 'styled-components';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  margin: 15px 0;
`;

export {
  InputContainer,
};
